'use client';

import { useCallback, useState } from 'react';
import { useWizardContext } from '../../hooks/useWizardContext';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import type { UrgencyType } from '../../types';
import { RadioGroup } from '../shared/RadioGroup';
import { StepLayout } from '../shared/StepLayout';

const URGENCY_OPTIONS = [
  {
    value: 'Right away-I have an urgent medical need or concern',
    label: 'Right away—I have an urgent medical need or concern',
  },
  {
    value: 'Soon-I want to be proactive about my future medical needs',
    label: 'Soon—I want to be proactive about my future medical needs',
  },
  {
    value: "Not sure yet-I'm still learning more about Sollis",
    label: "Not sure yet—I'm still learning more about Sollis",
  },
];

/**
 * Urgency step - captures how soon the user plans to use their membership.
 */
export function UrgencyStep() {
  const { state, dispatch } = useWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const urgency = state.formData?.urgency;

  const handleChange = useCallback(
    (value: string) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { urgency: value as UrgencyType },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (!urgency) {
        setError('Please select an option');
        return;
      }

      goToNextStep();
    },
    [urgency, goToNextStep]
  );

  return (
    <StepLayout
      heading='When do you want to start this membership?'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <RadioGroup
        name='urgency'
        options={URGENCY_OPTIONS}
        value={urgency}
        onChange={handleChange}
        error={error}
      />
    </StepLayout>
  );
}
